import { API_URL } from "../constant";

class ApiService {
  constructor() {
    this.token = localStorage.getItem("auth_token");
  }

  setToken(token) {
    this.token = token;
    localStorage.setItem("auth_token", token);
  }

  getToken() {
    return this.token;
  }

  clearToken() {
    this.token = null;
    localStorage.removeItem("auth_token");
  }

  async request(endpoint, options = {}) {
    const url = `${API_URL}${endpoint}`;
    const config = {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      ...options,
    };

    if (this.token) {
      config.headers.Authorization = `Bearer ${this.token}`;
    }

    try {
      const response = await fetch(url, config);
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Something went wrong");
      }

      return data;
    } catch (error) {
      console.error("API request failed:", error);
      throw error;
    }
  }

  // Auth methods
  async forgotPassword(email) {
    return this.request("/superadmin/forgot-password", {
      method: "POST",
      body: JSON.stringify({ email }),
    });
  }

  async verifyPasswordResetOTP(email, otp) {
    return this.request("/superadmin/verify-password-otp", {
      method: "POST",
      body: JSON.stringify({ email, otp }),
    });
  }

  async resetPassword(email, otp, password, password_confirmation) {
    return this.request("/superadmin/reset-password", {
      method: "POST",
      body: JSON.stringify({
        email,
        otp,
        password,
        password_confirmation,
      }),
    });
  }

  async resendPasswordResetOTP(email) {
    return this.request("/superadmin/resend-password-reset", {
      method: "POST",
      body: JSON.stringify({ email }),
    });
  }

  // SuperAdmin login
  async superAdminLogin(email, password) {
    return this.request("/superadmin/login", {
      method: "POST",
      body: JSON.stringify({ email, password }),
    });
  }

  async verifySuperAdminOTP(userId, otp) {
    return this.request("/superadmin/verify-superadmin-otp", {
      method: "POST",
      body: JSON.stringify({ user_id: userId, otp }),
    });
  }

  async resendLoginOTP(email) {
    return this.request("/superadmin/resend-login-otp", {
      method: "POST",
      body: JSON.stringify({ email }),
    });
  }

  // Get current user
  async getCurrentUser() {
    return this.request("/superadmin/me");
  }

  // Logout
  async logout() {
    return this.request("/superadmin/logout", {
      method: "POST",
    });
  }

  async getPublicWalletChartData() {
    return this.request("/public/wallet/chart-data");
  }

  async getPublicWalletChartDataByYear(year) {
    return this.request(`/public/wallet/chart-data/${year}`);
  }

  // User Analytics methods
async getUserCountsByMonth(year = null) {
  const endpoint = year 
    ? `/analytics/user-counts/monthly?year=${year}`
    : '/analytics/user-counts/monthly';
  return this.request(endpoint);
}

async getUserCountsByYear(year) {
  return this.request(`/analytics/user-counts/yearly?year=${year}`);
}

async getCurrentMonthUserCounts() {
  return this.request('/analytics/user-counts/current-month');
}

async getUserCountsByMonthOptimized(year = null) {
  const endpoint = year 
    ? `/analytics/user-counts/monthly-optimized?year=${year}`
    : '/analytics/user-counts/monthly-optimized';
  return this.request(endpoint);
}

}


export default new ApiService();
